"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const updater_1 = require("@festival/tag/updater");
const selected_list_1 = require("@festival/tag/selected-list");
const dropdown_list_1 = require("@festival/tag/dropdown-list");
class Box extends React.Component {
    render() {
        const { type, complete, codes } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(updater_1.default, null),
            React.createElement("div", { className: "tag-box mb-2 d-flex justify-content-between" },
                React.createElement(selected_list_1.default, { type: type, complete: complete, codes: codes }),
                complete !== true && (React.createElement(dropdown_list_1.default, { type: type })))));
    }
}
exports.Box = Box;
exports.default = mobx_react_1.observer(Box);
